import { Component } from '@angular/core';
import { ApidataService } from '../apidata.service';
import { CommonModule } from '@angular/common';
import swal from 'sweetalert2';
@Component({
  selector: 'app-verify',
  standalone: true,
  imports: [ CommonModule],
  templateUrl: './verify.component.html',
  styleUrl: './verify.component.css',
  providers: [ApidataService]
})
export class VerifyComponent {
  selectedprice_id;
  selectedplanamount;
  selectedplan;
  userid
  constructor(private apirequest:ApidataService){}
  ngOnInit() {
 
   this.userid= localStorage.getItem('signupid')
    this.selectedplan = localStorage.getItem('plan');
    this.selectedplanamount = localStorage.getItem('amount');
   
    this.selectedprice_id =     localStorage.getItem('price_id')
 

  }
  public againsent_code(){
    this.apirequest.resentcodeforaccount(this.userid).subscribe(data=>{
 
      if(data.meta.code == 200){
      
        this.showSuccess("Account verification mail resend successfuly.", "");
      }
      if(data.meta.code == 201){
      
        this.sendEmail("Account already verified.", "");
      }
      if(data.meta.code == 400){
      
        this.sendEmail("leaset try again later.", "");
      }
    })
  }
countinuetopayment(){
  this.apirequest.callpaymentapi(this.userid, this.selectedprice_id).subscribe(data =>{

    if (data.meta.code == 403){
      this.showAlert(data.response, "");
    }
    else if (data.meta.code == 400) {
 
      this.showAlert(data.response,"");
    }
    else if (data.meta.code == 401) {
   
      this.showAlert(data.response,"");
    }
    else{
         window.open(data.url, '_blank');
  
    }
     })

}

error: boolean = false;
errorAlerts;
success: boolean = false;
successAlert;
resendEmail: boolean = false;
send;
sendEmail(message, selector){
  this.send = message;
  $(selector).css('border-color', 'red');
  this.resendEmail = true;
  $('#errorAlerts;').show();
  setTimeout(() => {
    $('#errorAlerts;').hide();
    $(selector).css('border-color', '#e7e7ec');
    this.resendEmail = false;
  }, 4000);
  let backdrop = document.querySelector('.modal-backdrop');
  if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'modal-backdrop fade show'; 
      document.body.appendChild(backdrop); 
  }
}
showAlert(message, selector) {


  this.errorAlerts = message;
  $(selector).css('border-color', 'red');
  this.error = true;
  $('#errorAlerts;').show();
  setTimeout(() => {
    $('#errorAlerts;').hide();
    $(selector).css('border-color', '#e7e7ec');
    this.error = false;
  }, 4000);
  let backdrop = document.querySelector('.modal-backdrop');
  if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'modal-backdrop fade show'; 
      document.body.appendChild(backdrop); 
  }
}

showSuccess(message, selector) {
  this.successAlert = message;
  this.success = true;
  $('#successAlert').show();
  setTimeout(() => {
    $('#successAlert').hide();
    $(selector).css('border-color', '#e7e7ec');
    this.success = false;
  }, 4000);
}

closeErrorDiv() {
  this.error = false; 
}
closesendDiv() {
  this.resendEmail = false; 

}

}
